<template>
    <div class="buy-account-info-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="buy-account-info-content mask-content">
            <span class="close-icon" @click="isShow = false"></span>
            <div class="mask-title">账号信息</div>
            <template v-if="Array.isArray(accountInfo) && moreGoods">
                <div class="more-cdk-wrap">
                    <div class="more-cdk-inner hide-scroll">
                        <div class="more-cdk" v-for="(item, index) in accountInfo" :key="index">{{ item }}</div>
                    </div>
                </div>
            </template>
            <template v-else-if="Array.isArray(accountInfo)">
                <div class="account-info-wrap">
                    <div class="info-item" v-for="(item, index) in accountInfo" :key="index">
                        <span class="field">
                            <i class="ellipsis">{{ item.key }}</i>
                        </span>
                        <span class="field-value">
                            <i class="ellipsis"> {{ item.value }}</i>
                        </span>
                    </div>
                </div>
                <div class="tip-txt">建议获取后，前往修改密码，保障您的账号安全</div>
            </template>
            <template v-else>
                <div class="cdk-str">{{ accountInfo }}</div>
            </template>
            <div class="operate-btn-wrap" :class="{ disabled: blank }" @click="copy">
                <span class="sp2">全部复制</span>
            </div>
        </div>
    </div>
</template>

<script>
import { queryCdkOrderDetail } from '@/http/api/order'

export default {
    name: 'BuyAccountInfo',
    data() {
        return {
            isShow: false,
            accountInfo: '',
            orderNo: '',
            blank: false,
            moreGoods: false
        }
    },
    watch: {
        isShow: function(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('buy-account-info-page')
                })
            } else {
                this.accountInfo = ''
                this.orderNo = ''
                this.blank = false
                this.moreGoods = false
            }
        }
    },
    methods: {
        show(order) {
            this.isShow = true
            this.orderNo = order

            const query = { orderNo: this.orderNo, id: 0 }
            this.getCdkDetail(query)
        },
        getCdkDetail(query) {
            queryCdkOrderDetail(query).then(res => {
                if (res.code == 200 && res.data instanceof Object) {
                    if (Array.isArray(res.data.cdkList)) {
                        var cdk = res.data.cdkList[0]
                        this.original_cdk = cdk
                        if (res.data.cdkList.length > 1) {
                            this.moreGoods = true
                            this.accountInfo = [...res.data.cdkList]
                        } else if (cdk && cdk.indexOf('----') > -1) {
                            var tempArr = cdk.split('----')
                            var targetStrArr = []
                            $.each(tempArr, function(index, item) {
                                var engColonIndex = item.indexOf(':'),
                                    zhColonIndex = item.indexOf('：'),
                                    targetIndex,
                                    key = '',
                                    value = ''
                                try {
                                    var targetIndex = ''
                                    if (engColonIndex > -1 && zhColonIndex > -1) {
                                        targetIndex = Math.min(engColonIndex, zhColonIndex)
                                    } else if (engColonIndex > -1) {
                                        targetIndex = engColonIndex
                                    } else if (zhColonIndex > -1) {
                                        targetIndex = zhColonIndex
                                    } else {
                                        targetIndex = 0
                                    }
                                    key = item.slice(0, targetIndex)
                                    value = item.slice(targetIndex + 1)
                                } catch (error) {
                                    key = ''
                                    value = item
                                }

                                if (key && value) {
                                    targetStrArr.push({ key, value })
                                }
                            })
                            this.accountInfo = targetStrArr
                        } else if (cdk) {
                            this.accountInfo = cdk
                        } else {
                            this.blank = true
                            this.accountInfo = '因商品发货有延迟，可稍后在我的订单查看'
                        }
                    }
                }
            })
        },
        copy() {
            if (this.blank) {
                return false
            }

            let copyStr = ''
            if (Array.isArray(this.accountInfo) && this.moreGoods) {
                for (let i = 0; i < this.accountInfo.length; i++) {
                    let item = this.accountInfo[i],
                        isNewLine = '\n'
                    if (item) {
                        if (i == this.accountInfo.length - 1) {
                            isNewLine = ''
                        }
                        copyStr += `${item}${isNewLine}`
                    }
                }
            } else if (Array.isArray(this.accountInfo)) {
                for (let i = 0; i < this.accountInfo.length; i++) {
                    let item = this.accountInfo[i],
                        isNewLine = '\n'
                    if (i == this.accountInfo.length - 1) {
                        isNewLine = ''
                    }
                    copyStr += `${item.key}：${item.value}${isNewLine}`
                }
            } else {
                copyStr = this.accountInfo
            }
            this.$Utils.copy.call(this, copyStr)
        }
    }
}
</script>

<style lang="less" scoped>
.buy-account-info-page {
    .buy-account-info-content {
        position: fixed;
        padding-top: 36px;
        padding-bottom: 30px;
        transform: translate(-50%, -50%);
        width: 540px;
        background: @bg-color-dialog;

        .mask-title {
            text-align: center;
            color: @color-txt-high;
            font-size: 20px;
            line-height: 26px;
        }

        .account-info-wrap {
            padding: 26px 0 10px;

            .info-item {
                margin: 0 auto;
                display: flex;
                height: 40px;
                width: 360px;
                margin-bottom: 14px;
                background-color: #090e0f;
                border-radius: 20px;

                &:last-child {
                    margin-bottom: 0;
                }

                span {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                }

                .field {
                    display: flex;
                    width: 68px;
                    margin-right: 10px;
                    font-size: 12px;
                    padding-left: 20px;
                    flex-shrink: 0;
                    color: #999999;

                    i {
                        display: inline-block;
                        width: 48px;
                    }
                }

                .field-value {
                    color: rgba(255, 255, 255, 0.7);
                    flex: 1;

                    i {
                        display: inline-block;
                        width: 260px;
                    }
                }
            }
        }

        .tip-txt {
            text-align: center;
            font-size: 14px;
            line-height: 14px;
            color: rgba(255, 255, 255, 0.4);
            margin-bottom: 20px;
        }

        .more-cdk-wrap {
            height: 200px;
            padding: 24px 0;

            .more-cdk-inner {
                height: 100%;
                overflow-y: auto;

                .more-cdk {
                    width: 100%;
                    text-align: center;
                    font-size: 16px;
                    color: rgba(255, 255, 255, 0.7);
                    margin-bottom: 8px;
                }
            }
        }

        .cdk-str {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 200px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.7);
        }

        .operate-btn-wrap {
            margin: 0 auto;
            .button-linear();

            &.disabled {
                cursor: not-allowed;
            }
        }
    }
}
</style>
